import { Component, OnDestroy, OnInit } from '@angular/core';
import { ServicioService} from 'app/services/servicio.services';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';


@Component({
  selector: 'app-resultado',
  templateUrl: './resultado.component.html',
  styleUrls: ['./resultado.component.css']
})
export class ResultadoComponent implements OnInit, OnDestroy {
  dtOptions:any;
  dtTrigger: Subject<any> = new Subject<any>();
  constructor(private _servicios: ServicioService, private _router: Router) { }
  private obra: any;
  public Datos: any;
  public table : any;
  private infoObra: any;

  ngOnInit() {
    if(sessionStorage.getItem("token")== null){
      this._router.navigateByUrl("login");
    }    
    this.obra = sessionStorage.getItem("CodObra");
    this.obtenerDatosResultados();
     /* opciones tabla*/
     this.dtOptions = {
      pagingType: 'full_numbers',
      "scrollX": true,
      pageLength: 10,
      language: {
        processing: "Procesando...",
        search: "Buscar:",
        lengthMenu: "Mostrar _MENU_  registros",
        info: "Mostrando desde _START_ al _END_ de _TOTAL_ elementos",
        infoEmpty: "Mostrando ningún elemento.",
        infoFiltered: "(filtrado _MAX_ elementos total)",
        infoPostFix: "",
        loadingRecords: "Cargando registros...",
        zeroRecords: "No se encontraron registros",
        emptyTable: "No hay datos disponibles en la tabla",
        paginate: {
          first: "Primero",
          previous: "Anterior",
          next: "Siguiente",
          last: "Último",
          
        },
        aria: {
          sortAscending: ": Activar para ordenar la tabla en orden ascendente",
          sortDescending: ": Activar para ordenar la tabla en orden descendente"
        },
        
      },
      dom: 'Bfrtip',
      buttons: [
       {extend: 'copy',
        text: 'Copiar'},
        {
          extend: 'excel',
          text: 'Exportar a Excel'
        },
        {
          extend: 'print',
          text: 'Vista de impresión'
        }
    ]
      
    };
    
    this.obtenerObra();
    console.log(this.table)
       
    

  }

  certificado(ncertificado, muestra){
    console.log("test");
    sessionStorage.setItem("certificado",ncertificado);
    sessionStorage.setItem("numeroMuestra", muestra);
    console.log(sessionStorage.getItem("CodObra"));

    

  }

  obtenerDatosResultados(){
    this._servicios.obtenerResultados(this.obra).subscribe(
      result =>{
        console.log(result);
        this.Datos = result;
        this.table = this.Datos.resultados;
        this.dtTrigger.next();
      }, error => {
        
        this._router.navigateByUrl("login");
    });
  }

  obtenerObra(){
    this._servicios.obtenerInformacionObra(this.obra).subscribe(
      result =>{
        this.infoObra = result;
      }, error => {
        
        this._router.navigateByUrl("login");
    });
  }
  ngOnDestroy(): void{
    this.dtTrigger.unsubscribe();
  }


}



// WEBPACK FOOTER //
// ./src/app/resultado/resultado.component.ts